var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('line',{class:{strong: _vm.strong},attrs:{"x1":_vm.xEdgeTop,"y1":_vm.yEdgeTop,"x2":_vm.xEdgeBot,"y2":_vm.yEdgeBot}}),_vm._v(" "),_c('circle',{attrs:{"cx":_vm.xDotTop,"cy":_vm.yDotTop,"r":"1.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":_vm.xDotBot,"cy":_vm.yDotBot,"r":"1.5"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3322c47b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Edge.vue
// module id = 88
// module chunks = 0